import { TextField, InputAdornment } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Full-width Text Input Widget - for longer fields or standalone inputs
export const WideTextWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, placeholder, schema } = props;

  return (
    <TextField
      id={id}
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value || undefined)}
      disabled={disabled}
      slotProps={{
        input: {
          readOnly: readonly,
          endAdornment: schema.description ? (
            <InputAdornment position="end">
              {renderDescriptionTooltip(schema.description)}
            </InputAdornment>
          ) : null,
        },
      }}
      placeholder={placeholder}
      label={renderLabel(label, !!required)}
      required={required}
      fullWidth
      size="small"
      variant="outlined"
      sx={inputStyles}
    />
  );
};
